import { styled } from "@mui/material";
import { COLORS } from "../../../constants/colors";

export const MenuIcon = styled("span")`
  color: ${COLORS.TEXT_SECONDARY};
  display: inline-flex;

  & > * {
    height: 0.8em;
    width: 0.8em;
  }
`;
